import React from "react";
import { Spacer } from "../../components/_shared-components/arrangement/Space";
import { Maybe } from "../../utils/fp/small-fp-utils";
import { ContentFulComponents } from "@swo/storefront";

export function ComponentSpacing(props: {
  index: number;
  previousComponent:
    | ContentFulComponents
    | { __typename: "custom"; node: React.JSX.Element | null }
    | null
    | undefined
    | string;
  noSpaceForFirstComponent: boolean;
  componentTypeName: ContentFulComponents["__typename"];
}) {
  const isSpacingDisabled = props.noSpaceForFirstComponent && props.index === 0;

  if (isSpacingDisabled) {
    return null;
  }

  const { previousComponent, componentTypeName } = props;

  return (
    <InterComponentAutoSpacer
      previousComponentTypeName={
        !previousComponent || typeof previousComponent === "string" ? undefined : previousComponent?.__typename
      }
      currentComponentTypeName={componentTypeName}
    />
  );
}

export function InterComponentAutoSpacer(props: {
  previousComponentTypeName: Maybe<ContentFulComponents["__typename"] | "custom">;
  currentComponentTypeName: ContentFulComponents["__typename"];
}) {
  const { previousComponentTypeName, currentComponentTypeName } = props;

  // This is a first content component.
  if (typeof previousComponentTypeName === "undefined") {
    if (currentComponentTypeName === "ComponentTextAndImage") {
      return <Spacer size={"md"} />;
    } else {
      return null;
    }
  } else {
    if (previousComponentTypeName === "ComponentHeroImage" && currentComponentTypeName === "ComponentHeroImage") {
      // Don't auto-insert space between two, full-width visual images
      return null;
    } else if (previousComponentTypeName === "Component3DModel") {
      return <Spacer size={"md"} />;
    } else {
      return <Spacer size={"md"} />;
    }
  }
}
